// bookingReducer.js

const initialState = {
    totalCost: 0,
    costPerPerson: 0,
    transferType:'',
    book:null,
    short_description:null,
    currency:''
  };
  
  const bookingReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'UPDATE_BOOKING_PRICE':
        return {
          ...state,
          totalCost: action.payload.totalCost,
          costPerPerson: action.payload.costPerPerson,
          transferType: action.payload.transferType,
          book: action.payload.book,
          short_description: action.payload.short_description,
          currency:action.payload.currency,
        };
      default:
        return state;
    }
  };
  
  export default bookingReducer;
  